// Global fonksiyon olarak tanımla
function initializeProductCardSwipers() {
    // Mobilde hover işlemlerini devre dışı bırak
    const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    if (isTouchDevice) return;
    
    /**
     * Finds all product cards on the page and initializes a Swiper slider
     * for each variant group within each card, enabling free-scrolling.
     */
    const productCards = document.querySelectorAll('.product__card');
    
    productCards.forEach(card => {
        const sliders = card.querySelectorAll('.variant-slider');
        
        sliders.forEach(slider => {
            // Eğer zaten Swiper instance'ı varsa destroy et
            if (slider.swiper) {
                slider.swiper.destroy(true, true);
            }
            
            new Swiper(slider, {
                slidesPerView: 'auto',
                spaceBetween: 10,
                freeMode: true,
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initializeProductCardSwipers();
});

function product_runtime_init() {
    const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    if (isTouchDevice) return;
    const products = document.querySelectorAll('.product__card')

    if (products && products.length > 0) {
        products.forEach((/** @type HTMLDivElement */product) => {
            // Prevent image link from interfering with hover effects
            const imageLink = product.querySelector('.product__card__image__link')
            if (imageLink) {
                imageLink.addEventListener('mouseover', (e) => {
                    e.stopPropagation()
                    // Trigger parent hover effect
                    product.dispatchEvent(new Event('mouseover'))
                })
                
                imageLink.addEventListener('mouseout', (e) => {
                    e.stopPropagation()
                    // Trigger parent mouseout effect
                    product.dispatchEvent(new Event('mouseout'))
                })
            }

            // Enhanced variant selection interactions
            const colorVariants = product.querySelectorAll('.produc__card__detail .product__card__color__variant a')
            const textVariants = product.querySelectorAll('.produc__card__detail .variant__option')
            
            // Add click tracking for color variants
            colorVariants.forEach(colorLink => {
                colorLink.addEventListener('click', (e) => {
                    // Optional: Add analytics tracking here
                    // console.log('Color variant clicked:', colorLink.getAttribute('title'))
                })
            })
            
            // Add click tracking for all text variants (size, material, etc.)
            textVariants.forEach(variantLink => {
                variantLink.addEventListener('click', (e) => {
                    // Optional: Add analytics tracking here
                    // console.log('Variant clicked:', variantLink.textContent, 'Available:', !variantLink.classList.contains('variant__option--unavailable'))
                    
                    // Add visual feedback for clicked variant
                    if (!variantLink.classList.contains('variant__option--unavailable')) {
                        variantLink.style.backgroundColor = '#f0f0f0'
                        setTimeout(() => {
                            variantLink.style.backgroundColor = ''
                        }, 200)
                    }
                })
                
                // Enhanced hover effects for variants
                variantLink.addEventListener('mouseenter', () => {
                    if (!variantLink.classList.contains('variant__option--unavailable')) {
                        variantLink.style.transform = 'scale(1.05)'
                    }
                })
                
                variantLink.addEventListener('mouseleave', () => {
                    variantLink.style.transform = ''
                })
            })
            
            // Lazy load optimization for variant images
            const variantImages = product.querySelectorAll('.produc__card__detail img')
            variantImages.forEach(img => {
                img.addEventListener('load', () => {
                    img.style.opacity = '1'
                })
                img.style.opacity = '0.7'
                img.style.transition = 'opacity 0.3s ease'
            })
        })
    }
}